import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y: 48 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ index, label, title, className = "" }) => (
    <Reveal className={className}>
        <div className="flex items-baseline gap-4 mb-6">
            <span className="font-mono text-sm text-sky-400 tracking-[0.3em]">{index}</span>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-slate-500">{label}</span>
        </div>
        <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight text-slate-50">
            {title}
        </h2>
    </Reveal>
);
